<template>
  <div v-if="can('reports.baggage')">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <router-link to="/" tag="li" class="breadcrumb-item"><a href="">{{ i18n('Main') }}</a></router-link>
        <router-link to="/baggage-reports" tag="li" class="breadcrumb-item"><a href="">{{ i18n('Baggage') }}</a>
        </router-link>
      </ol>
    </nav>

    <div class="base_box_hdr">
      <div class="base_box_ttl">
        <div class="row">
          <div class="col-sm-8">
            <h1 class="title">{{ i18n('Baggage') }}</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="base_box_main">
      <div class="base_box">
        <div class="base_box_cnt">
          <!--      <nav>-->
          <!--        <div class="nav nav-tabs" id="nav-tab01" role="tablist">-->
          <!--          <a class="nav-item nav-link active" id="nav-01-tab01" data-toggle="tab" href="#nav-01-1" role="tab"-->
          <!--             aria-controls="nav-01-1" aria-selected="true">{{ i18n('By Trips') }}</a>-->
          <!--          <a class="nav-item nav-link" id="nav-02-tab02" data-toggle="tab" href="#nav-02-1" role="tab"-->
          <!--             aria-controls="nav-02-1">{{ i18n('By Transporters') }}</a>-->
          <!--        </div>-->
          <!--      </nav>-->
          <!--      <div class="tab-content">-->
          <!--        <div class="tab-pane fade show active" id="nav-01-1" role="tabpanel" aria-labelledby="nav-01-tab">-->
          <p>{{ i18n('Trip departure time') }}</p>
          <div class="row mb-3">
            <div class="col-xl-5 col-sm-12">
              <div class="form-inline">
                <label class="col-form-label fs-12">{{ i18n('from date') }}:</label>
                <div class="col-sm-8">
                  <div class="input-group day date">
                    <datepicker
                        v-model="dateFrom"
                        :inputClass="['form-control base_input']"
                        :bootstrap-styling="true"
                        :calendar-button="true"
                        calendar-button-icon="mdi mdi-calendar"
                        format="dd.MM.yyyy"></datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-5 col-sm-12">
              <div class="form-inline">
                <label class="col-form-label fs-12">{{ i18n('to date') }}:</label>
                <div class="col-sm-8">
                  <div class="input-group day date">
                    <datepicker
                        v-model="dateTo"
                        :inputClass="['form-control base_input']"
                        :bootstrap-styling="true"
                        :calendar-button="true"
                        calendar-button-icon="mdi mdi-calendar"
                        format="dd.MM.yyyy"></datepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-sm-12">
              <div class="form-inline justify-content-end">
                <button type="button" class="btn base_btn solid_blue waves-effect waves-light" @click="getReport">
                  {{i18n('To form')}}
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-bordered table-striped table-hover mb-0">
              <thead class="text-center">
              <tr>
                <th scope="col" rowspan="2">{{ i18n('Trip') }}</th>
                <th scope="col" rowspan="2">{{ i18n('Routes') }}</th>
                <th scope="col" rowspan="2">{{ i18n('Departure time') }}</th>
                <th scope="col" rowspan="2">{{ i18n('Transporter') }}</th>
                <th scope="col" rowspan="2">{{ i18n('Bus model') }}</th>
                <th scope="col" rowspan="2">{{ i18n('Bus number') }}</th>
                <th scope="col" rowspan="2">{{ i18n('Full name of the driver') }}</th>
                <th scope="col" colspan="2">{{ i18n('Selling (without returned tickets)') }}</th>
                <th scope="col" colspan="2">{{ i18n('Baggage return penalties') }}</th>
              </tr>
              <tr>
                <th scope="col">{{ i18n('Tickets count') }}</th>
                <th scope="col">{{ i18n('Amount') }}</th>
                <th scope="col">{{ i18n('Tickets count') }}</th>
                <th scope="col">{{ i18n('Amount') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="trip in report">
                <td>{{ trip.id }}</td>
                <td>{{ trip.route_name }}</td>
                <td>{{ trip.etd }}</td>
                <td>{{ trip.transporter_name }}</td>
                <td>{{ trip.bus_model }}</td>
                <td>{{ trip.bus_number }}</td>
                <td>{{ trip.driver_name }}</td>
                <td>{{ trip.baggage_tickets_count }}</td>
                <td>{{ trip.baggage_amount }}</td>
                <td>{{ trip.returned_baggage_tickets_count }}</td>
                <td>{{ trip.penalty_for_return }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <!--        </div>-->
          <!--        <div class="tab-pane fade show" id="nav-02-1" role="tabpanel" aria-labelledby="nav-01-tab">-->

          <!--        </div>-->
          <!--      </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";

    export default {
        name: "baggage",
        components: {Datepicker},
        data() {
            return {
                dateFrom: null,
                dateTo: null,
                loadingState: false,
                report: null,
            }
        },
        methods: {
            getReport() {
                this.loadingState = true;
                this.$api.post('reports.baggage-tickets-by-trip', {
                    dateFrom: this.dateFrom,
                    dateTo: this.dateTo
                }).then(res => {
                    if (!_.isEmpty(res.errors)) {
                        this.notifyError(res);
                        return;
                    }
                    this.report = res.data;
                }).catch(errResponse => {
                    errResponse = errResponse.response.data;
                    this.notifyError(errResponse);
                }).finally(() => {
                    this.loadingState = false;
                })
            },
            notifyError(errResponse) {
                let message = errResponse.message;
                if (errResponse.hasOwnProperty('errors')) {
                    for (let error in errResponse.errors) {
                        if (errResponse.errors[error].hasOwnProperty('message')) {
                            message = errResponse.errors[error].message;
                            continue;
                        }
                        if (errResponse.errors.hasOwnProperty(error)) {
                            message += "<br /> - " + errResponse.errors[error];
                        }
                    }
                }
                this.$notify({
                    type: 'error',
                    group: 'foo',
                    title: '',
                    text: message,
                });
            },
        }
    }
</script>

<style scoped>

</style>
